import { vellumApiSdk } from "@vellum/micro-app-auth";
import {
  getFriendlyDate,
  RecordTable,
  usePaginatedQuery,
  type Column,
} from "@vellum/ui";
import type { AdminUserSchema } from "@vellum/vellum-api";
import { useState } from "react";

import { ListPage } from "@/components/ListPage";
import { ADMIN_PAGE_SIZE } from "@/lib/pagination";

const COLUMNS: Column<AdminUserSchema>[] = [
  { header: "Name", render: (user) => user.name },
  { header: "Email", render: (user) => user.email },
  {
    header: "Role",
    render: (user) => user.role ?? "—",
    className: "hidden sm:table-cell",
  },
  {
    header: "Created",
    render: (user) => getFriendlyDate(user.created_at),
    className: "hidden md:table-cell",
  },
];

export function UsersPage() {
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(0);
  const needle = query.trim();

  const { items, total, loading, isFetching, error } =
    usePaginatedQuery<AdminUserSchema>(
      () =>
        vellumApiSdk.adminListUsers({
          query: {
            limit: ADMIN_PAGE_SIZE,
            offset: page * ADMIN_PAGE_SIZE,
            q: needle || undefined,
          },
        }),
      "Something went wrong loading users.",
      [page, needle],
    );

  return (
    <ListPage
      title="Users"
      subtitle="Every Luna user who can sign in"
      query={query}
      onQueryChange={(value) => {
        setQuery(value);
        setPage(0);
      }}
      searchPlaceholder="Name or email"
      loading={loading}
      isFetching={isFetching}
      error={error}
      page={page}
      pageSize={ADMIN_PAGE_SIZE}
      total={total}
      onPageChange={setPage}
    >
      <RecordTable
        columns={COLUMNS}
        rows={items}
        rowKey={(user) => user.id}
        emptyMessage={needle ? "No users match that search." : "No users yet."}
      />
    </ListPage>
  );
}
